export const ROLE_META = {
  client: { color: "#C9A96E", icon: "◆" },
  architect: { color: "#7EB8C9", icon: "▲" },
  contractor: { color: "#A8C97E", icon: "●" },
};
export const ROOMS_IDS = ["kitchen", "bathroom", "living", "bedroom", "entry"];
export const ROOM_ICON = { kitchen: "⬡", bathroom: "◎", living: "⬜", bedroom: "⬛", entry: "⬠" };
export const ROOM_LABELS = { kitchen: "Cuisine", bathroom: "Salle de bain", living: "Salon", bedroom: "Chambre", entry: "Entrée" };
export const ROLE_LABELS = { client: "Client", architect: "Architecte", contractor: "Entreprise" };
export const ROOM_WEIGHTS = { kitchen: 0.32, bathroom: 0.22, living: 0.18, bedroom: 0.14, entry: 0.06 };
